import React, { FC, ReactNode } from 'react';
import { Layout } from 'antd';

const { Content } = Layout;

interface IComponentProps {
  children?: ReactNode;
}

export const PageContent: FC<IComponentProps> = ({ children }) => {
  return <Content className="page-content">{children}</Content>;
};
